import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Avatar, device, fontSize, fontWeight, space, color } from '@ticketswap/solar'

const Wrapper = styled.div`
  align-items: center;
  background-color: ${color.white};
  border-radius: ${space[16]};
  display: inline-flex;
  max-width: 100%;
  padding-right: ${space[8]};
  font-size: ${fontSize[12]};

  @media ${device.tablet} {
    font-size: ${fontSize[14]};
    padding-right: ${space[12]};
  }
`

const StyledAvatar = styled(Avatar)`
  border: 2px solid white;
  margin-right: -${space[16]};
  max-height: ${space[24]};
  max-width: ${space[24]};

  @media ${device.tablet} {
    margin-right: -18px;
    min-height: ${space[32]};
    min-width: ${space[32]};
    max-height: ${space[32]};
    max-width: ${space[32]};
  }
`

const Info = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: 22px;
  overflow: hidden;
  padding: 3px 0;
  line-height: 1;

  @media ${device.tablet} {
    margin-left: ${space[24]};
    padding: 5px 0;
  }
`

const Name = styled.span`
  font-weight: ${fontWeight.semiBold};
  margin-right: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

function ArtistAvatarCount({ avatarCount, avatarsList, t, totalNumber, ...props }) {
  const avatars = avatarsList.slice(0, avatarCount)

  let remainingAvatars = null
  if (totalNumber > avatarCount) {
    remainingAvatars = totalNumber - avatarCount
  }

  if (avatars.length === 0) {
    return null
  }

  return (
    <Wrapper {...props}>
      {avatars.length > 0 &&
        avatars.map(({ id, avatar }) => <StyledAvatar key={id} size={24} src={avatar} />)}

      <Info>
        {avatars.length > 0 && (
          <Name>
            {avatars.map(({ id, name }, i, arr) => (
              <span key={id}>
                {name}
                {arr.length - 1 !== i && ', '}
              </span>
            ))}
          </Name>
        )}

        {remainingAvatars && (
          <span>
            {t('common:artist.avatarCount.remaining', {
              count: remainingAvatars,
            })}
          </span>
        )}
      </Info>
    </Wrapper>
  )
}

ArtistAvatarCount.propTypes = {
  avatarCount: PropTypes.number,
  avatarsList: PropTypes.array,
  t: PropTypes.func.isRequired,
  totalNumber: PropTypes.number,
}

export default ArtistAvatarCount
